import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import classNames from 'classnames';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { withStyles } from '@material-ui/styles';
import Box from '../../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const styles = (theme) => ({
  root: {},
  fields: {
    padding: theme.spacing(0),
  },
});

const FacetPlanOutcomeQuickEditRetirementLayout = ({ className, classes }) => {
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();

  const { refreshPageContentCollection } = usePageContentContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  const retirementAgeGoalSeekWizardRel = resource.relationship(fr.relationships.retirementAgeWizard.name);

  return (
    <Box
      className={classNames(classes.root, className)}
      test={'retirement-age-outcome-edit'}
    >
      <TitleSection />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      {retirementAgeGoalSeekWizardRel
          && <FDPrimaryActionButton
            onClick={() => loadModalCollectionByLink(retirementAgeGoalSeekWizardRel.link('related').url())}
            color={'primary'}
            size={'md'}
            variant={'outlined'}
            label={'Run Earliest Retirement Age Tool'}
            test={'facet-plan-retirement-age-tool'}
            isFullWidth
          />
      }
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={async () => {
          const resp = await onSubmit();
          if (resp) {
            clearModalCollection();
            refreshPageContentCollection();
          }
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanOutcomeQuickEditRetirementLayout.defaultProps = {
  className: '',
};

FacetPlanOutcomeQuickEditRetirementLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanOutcomeQuickEditRetirementLayout);
